import React, { ErrorInfo, PropsWithChildren } from 'react';
import ErrorBody from './ErrorBody';
import { reportBoundaryError } from './reportBoundaryError';

class ErrorPage extends React.Component<PropsWithChildren, { error: Error | null }> {
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return {
      error: error.message,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportBoundaryError(error, errorInfo);
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;
    return error
      ? (
        <div style={{
          position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        }}
        >
          <ErrorBody />
        </div>
      )
      : children;
  }
}

export default ErrorPage;
